import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import { myConfig } from "../config";
import { useHistory, useParams } from "react-router-dom";
import { Cancel, Flag, SettingsPhone } from "@material-ui/icons";
import codeJson from "../CountryCodes.json";
import lang from "./lang.json";
function LandingPage(props) {
  const [faqs, setFaqs] = useState([]);
  const [productdetails, setproductdetails] = useState({});
  const [lan, setlan] = useState({});
  const [trakinid, settrakingid] = useState("");
  const [countycoded, setcountrycode] = useState("");
  //const [dubai, setdubai] = useState(/dubai/);
  const [stc, setstc] = useState(/stc/);
  const [uae, setuae] = useState(/uae/);
  const [zong, setzong] = useState(/zong/);
  const [virgin, setvirgin] = useState(/virgin/);
  const [voda, setvoda] = useState(/voda/);
  const [beeline, setbeeline] = useState(/beeline/);
  const [tmobile, settmobile] = useState(/tmobile/);
  const [orange, setorange] = useState(/orange/);
  const [sierra, setsierra] = useState(/sierra/);
  const [play, setplay] = useState(/play/);
  const [plus, setplus] = useState(/plus/);
  const [grameen, setgrameen] = useState(/grameen/);
  const [phone, getphone] = useState("");
  const [phones, getphones] = useState("");
  const [sCountryCode, setsCountrycode] = useState();
  const [userip, setuserip] = useState("");
  const [browser, setbrowser] = useState("");
  const [operator_id, setoperator_id] = useState(0);
  const [otp, getotp] = useState("");
  const [conuty, getcountry] = useState("");
  const [conutys, getcountrys] = useState("");
  const [cgflow, setcgflow] = useState(false);
  const [checkflow, setcheckflow] = useState(false);
  const [show1, setshow1] = useState(false);
  const [show2, setshow2] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);
  const [playtype, setplantype] = useState("daily");
  const [service_no, setserviceno] = useState("skysport_daily");
  const [plan, setplan] = useState("daily");
  const [bulletImage, setbulletImage] = useState(
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAYAAABbjRdIAAAAAXNSR0IArs4c6QAAAhBJREFUSEu9ljtoFVEQhr9fELSwU1Ja+OhUEIuA2oqN+ABtxSKKxGCl+MBGSETsLNSIFoIWivhqrCzEEDurhGgr+AAV1EoT8ZeBc0K82b2792bvnXbZ+c78Z878I/oYyizbm4Gvkj72ij8PC4Dt58BTYFySm4a2wvYBj4EJYEjS2yaBrbBlwDtgHTAHjAGXJM02Af0PlqQ8HgDgInAB+AQclRTVLimKYCuB98Bl4B5wFTgA3ATOSPrRLXERLFUXVR0OOSX9sb0HuAaEzCOSHnUDLIOtTtWFfHfTAVYBo8Aw8Aw4IelDJ9BCWEoesm2TtHVhQtuDSdK1wFnghqS/daDtYBuAaP1dkl60AJcDp4HzwBvgmKTpKmApLFX3BFghaXdRItsbozJge2qoUUm/y6BVsJ3AS2BT2cltR44jwBXgSxoGr4qAbWGputfAN+BOhUwD6V2uAW6FzJK+L/ynDuwQcL/qPgq+f07P5GH+Vgd2EHjQJeykpPl/68BCxmj3uhFucRs41ZGMtncAhZddQo4hHs8gmmpRVHVjtP7eGiWFK8QsHZP0q+PWt50fdczDdjGZqpmqOlTVuBpqk+AncA64vqRxZTsP4rCboojVYbiRQWw7G2crKJah5izGdjbPqC5HtPN44+ZpO9aCMMocMz1ZC2znhWc9EO3cu4XH9n4gLL8vq1x/llTbW8KPerl+/wOf+cwegfM+6gAAAABJRU5ErkJggg=="
  );
  const [aff_id, setaff_id] = useState(0);
  const [click_id, setclick_id] = useState("");
  const [camp_id, setcamp_id] = useState(0);
  const [isSmsFlow, setSMSFlow] = useState(false);
  let history = useHistory();
  let { id } = useParams();

  async function checkActiveEffId(effId) {
    var otpurl = myConfig.billing_url + "check_affiliate.php?aff_id=" + effId;
    console.log(otpurl);
    axios.get(otpurl).then((Response) => {
      if (Response.data == "ACTIVE") {
      } else {
        window.location.href = "/fail?active=false";
      }
    });
  }
  async function subConfirm() {
    //   if (window.confirm("ნომრის "+localStorage.getItem('bmsisdn')+" ბალანსიდან ყოველდღე ჩამოიჭრება სერვისის საფასური 2 ₾. ადასტურებ სერვისის აქტივაციას?") == true) {
    // if (window.confirm(myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&cg_image_url=&mode=WAP&msisdn="+localStorage.getItem('bmsisdn')+"&product_id="+productdetails.product_id+"&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id="+aff_id+"&camp_id="+camp_id+"&other1=do_billing&other2=") == true) {

    var otpurl =
      myConfig.billing_url +
      "subscription.php?affiliate=" +
      localStorage.getItem("aff_id") +
      "&cg_image_url=&mode=WAP&msisdn=" +
      localStorage.getItem("bmsisdn") +
      "&product_id=" +
      productdetails.product_id +
      "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id=" +
      localStorage.getItem("aff_id") +
      "&camp_id=" +
      localStorage.getItem("camp_id") +
      "&other1=do_billing&other2=&aff_id=" +
      localStorage.getItem("aff_id") +
      "&aff_uniq_id=" +
      localStorage.getItem("click_id") +
      "&camp_id=" +
      localStorage.getItem("camp_id");
    var queryparams =
      "affiliate = " +
      localStorage.getItem("aff_id") +
      " | cg_image_url =  |mode = WAP | msisdn=" +
      localStorage.getItem("bmsisdn") +
      "| product_id = " +
      productdetails.product_id +
      "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | camp_id= " +
      localStorage.getItem("camp_id") +
      "| other1 = do_billing | other2 = &aff_id=" +
      localStorage.getItem("aff_id") +
      "&aff_uniq_id=" +
      localStorage.getItem("click_id") +
      "&camp_id=" +
      localStorage.getItem("camp_id");
    var gettime = new Date();
    var veriftotpurlreq =
      gettime + "| REQ |" + localStorage.getItem("bmsisdn") + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
    let finalobj9 = {
      security: "col#c4",
      logData: veriftotpurlreq,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj9);
    axios.get(otpurl).then((Response) => {
      var gettime = new Date();
      var veriftotpurlres =
        gettime + "| RES |" + localStorage.getItem("bmsisdn") + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
      var finalobj5 = {
        security: "col#c4",
        logData: veriftotpurlres,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj5);
      localStorage.removeItem("bmsisdn");
      localStorage.removeItem("aff_id");
      if (Response.data.status == "OK") {
        window.location.href = "/welcome";
      } else {
        window.location.href = "/fail";
      }
    });
  }
  async function callCancel() {
    localStorage.removeItem("bmsisdn");
    localStorage.removeItem("aff_id");
    window.location.href = "/fail";
  }
  useEffect(() => {
    localStorage.setItem("activetab", "promo");
    var str = localStorage.getItem("lang");
    if (stc.test(window.location.pathname) == true || uae.test(window.location.pathname) == true) {
      console.log("in", str);
      if (str == undefined) {
        str = localStorage.setItem("lang", "en");
      } else {
        console.log("else", str);
        if (str == "en" || str == "ar") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "en");
          str = "en";
        }
      }
      var smsFlow = "";
      var getnumber = window.location.search.split("?");
      if (getnumber.length > 1) {
        var url = new URL(window.location.href);
        var plans = url.searchParams.get("plan");
        var aff_ids = url.searchParams.get("aff_id");
        var click_ids = url.searchParams.get("click_id");
        var camp_ids = url.searchParams.get("camp_id");
        smsFlow = url.searchParams.get("sms");
        console.log("Setting SMS FLow",smsFlow);
        if(smsFlow!==undefined && smsFlow!== null && smsFlow !== ''){
          setSMSFlow(smsFlow === "yes" ? true : false);
          localStorage.setItem("sms", smsFlow);
        }else{
          localStorage.removeItem("sms");

        }

        console.log("plan", plans);
        console.log("aff_ids", aff_ids);
        console.log("click_ids", click_ids);
        console.log("camp_ids", camp_ids);
        console.log("smsFlow", smsFlow);
        setplan(plans);
        if (plans === "weekly") {
          localStorage.setItem("plan", "weekly");
        } else {
          localStorage.setItem("plan", "daily");
        }
        checkActiveEffId(aff_ids);
        setaff_id(aff_ids);
        setclick_id(click_ids);
        setcamp_id(camp_ids);
        setoperator_id(144);
      }else{
        var sms = localStorage.getItem("sms", smsFlow);
        setSMSFlow(sms === "yes" ? true : false);

      }

      setcheckflow(false);
      setcgflow(false);
    }

    if (str == "en") {
      console.log("en");
      setlan(lang.en);
    } else if (str == "zoen") {
      setlan(lang.zoen);
    } else if (str == "ar") {
      console.log("en", lang.ar);
      setlan(lang.ar);
    } else if (str == "var") {
      setlan(lang.var);
    } else if (str == "ven") {
      setlan(lang.ven);
    } else if (str == "voen") {
      setlan(lang.voen);
    } else if (str == "boen") {
      setlan(lang.boen);
    } else if (str == "boar") {
      setlan(lang.boar);
    } else if (str == "plten") {
      setlan(lang.plten);
    } else if (str == "ploen") {
      setlan(lang.ploen);
    } else if (str == "oslen") {
      setlan(lang.oslen);
    } else if (str == "plpen") {
      setlan(lang.plpen);
    } else if (str == "plppen") {
      setlan(lang.plppen);
    } else if (str == "en_gr") {
      setlan(lang.en_gr);
    }
  });

  useEffect(() => {
    var countryCodes;

    if (
      stc.test(window.location.pathname) == true ||
      uae.test(window.location.pathname) == true ||
      zong.test(window.location.pathname) == true ||
      virgin.test(window.location.pathname) == true ||
      voda.test(window.location.pathname) == true ||
      beeline.test(window.location.pathname) == true ||
      tmobile.test(window.location.pathname) == true ||
      orange.test(window.location.pathname) == true ||
      sierra.test(window.location.pathname) == true ||
      play.test(window.location.pathname) == true ||
      plus.test(window.location.pathname) == true ||
      grameen.test(window.location.pathname) == true
    ) {
      console.log("in here");
      const fetchDatas = async () => {
        var str = window.location.pathname;
        const dataes = codeJson.filter((i) => i.link === str);
        console.log("dataes", dataes);
        if (dataes.length > 0) {
          window.sessionStorage.setItem("path", dataes[0].link);
          window.sessionStorage.setItem("dialCode", dataes[0].dial_code.slice(1));

          getcountry(dataes[0].dial_code.slice(1));
          getcountrys("+" + dataes[0].dial_code.slice(1));
          history.push(window.location.pathname);
        } else {
          history.push("/notfound");
        }
        const dataArrays = codeJson.filter((i) => i.link === str);
        setproductdetails(dataArrays[0]);
      };
      fetchDatas();
    } else {
      console.log("else here");
      const fetchData = async () => {
        const result = await axios(myConfig.billing_url + "countryCode.php");
        //http://13.126.46.199:8080/ssn/contentDetailBySubcategoryNCategory/?categoryId=1&subcategoryId=1&contentId=1&contrycode=91
        window.sessionStorage.setItem("sCountryCode", result.data.geoplugin_countryCode);
        setuserip(result.data.geoplugin_request);
        var str = window.location.pathname;
        const dataes = codeJson.filter((i) => i.link === str);
        console.log("dataes", dataes);
        if (dataes.length > 0) {
          window.sessionStorage.setItem("path", dataes[0].link);
          history.push(window.location.pathname);
        } else {
          history.push("/notfound");
        }

        const dataArray = codeJson.filter((i) => i.code === result.data.geoplugin_countryCode);
        console.log(dataArray);
        if (dataArray.length > 0) {
          // setproductdetails(dataArray[0])
          window.sessionStorage.setItem("dialCode", dataArray[0].dial_code.slice(1));

          getcountry(dataArray[0].dial_code.slice(1));
          getcountrys("+" + dataArray[0].dial_code.slice(1));
        }

        const dataArrays = codeJson.filter((i) => i.link === str);
        setproductdetails(dataArrays[0]);
      };
      fetchData();
    }

    // localStorage.removeItem("lang")

    var browser = (function () {
      var test = function (regexp) {
        return regexp.test(window.navigator.userAgent);
      };
      switch (true) {
        case test(/edg/i):
          return "Microsoft Edge";
        case test(/trident/i):
          return "Microsoft Internet Explorer";
        case test(/firefox|fxios/i):
          return "Mozilla Firefox";
        case test(/opr\//i):
          return "Opera";
        case test(/ucbrowser/i):
          return "UC Browser";
        case test(/samsungbrowser/i):
          return "Samsung Browser";
        case test(/chrome|chromium|crios/i):
          return "Google Chrome";
        case test(/safari/i):
          return "Apple Safari";
        default:
          return "Other";
      }
    })();
    setbrowser(browser);

    $("#subscribeMsisdn").show();
    $("#verify").hide();
  }, []);

  useEffect(() => {
    if (virgin.test(window.location.pathname) == true) {
      if (localStorage.getItem("update") == "1") {
        var str =
          localStorage.getItem("plan") +
          "_" +
          localStorage.getItem("aff_id") +
          "_" +
          localStorage.getItem("click_id") +
          "_" +
          localStorage.getItem("camp_id") +
          "_" +
          Math.floor(1000 + Math.random() * 9000);
        console.log(str);
        window.location.href =
          "http://sdp.altruistindia.com:8080/reports/header.php?UserName=IbuDigital&Password=d5ba5e842aace15863f3c34eda86251e&Ref=" + str;
      }
    }
  }, [localStorage.getItem("click_id") != null ? localStorage.getItem("click_id") : ""]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios(myConfig.server_url + "listAllFAQ/", {
        headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
      });
      setFaqs(result.data.listData);
    };
    fetchData();
  }, []);

  const checknumber = (e) => {
    if (e.target.value.length > 0) {
      getphone(e.target.value);
      $("#msisdn").removeClass("buttondis");
    } else {
      getphone(e.target.value);
      $("#msisdn").addClass("buttondis");
    }
  };

  const checkotp = (e) => {
    if (e.target.value.length == 4) {
      getotp(e.target.value);
      $("#msisdn").removeClass("buttondis");
    } else {
      getotp(e.target.value);
      $("#msisdn").addClass("buttondis");
    }
  };

  const verifyotp = () => {
    var dial_code = window.sessionStorage.getItem("dialCode");
    console.log(dial_code);
    if (otp != "undefined") {
      if (beeline.test(window.location.pathname) == true || sierra.test(window.location.pathname) == true) {
        if (otp.length == 5) {
          if (camp_id === NaN) {
            camp_id = 3;
          }
          var otpurl =
            myConfig.billing_url +
            "subscription.php?affiliate=" +
            aff_id +
            "&cg_image_url=&mode=WAP&msisdn=" +
            conuty +
            phone +
            "&product_id=" +
            productdetails.product_id +
            "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id=" +
            aff_id +
            "&camp_id=" +
            camp_id +
            "&other1=verify_otp&other2=" +
            otp;
          var queryparams =
            "affiliate = " +
            aff_id +
            " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
            conuty +
            phone +
            "| product_id = " +
            productdetails.product_id +
            "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 = verify_otp | other2 = " +
            otp;
          var gettime = new Date();
          var veriftotpurlreq =
            gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
          var finalobj9 = {
            security: "col#c4",
            logData: veriftotpurlreq,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj9);
          axios.get(otpurl).then((Response) => {
            var obj = {
              status: Response.data.status,
              ip: browser,
              agent: navigator.userAgent,
              response: Response,
              mobile_no: conuty + phone,
              productdetails: productdetails.product_id,
            };
            var obje = JSON.stringify(obj);
            var finalobj = {
              security: "col#c4",
              logData: obje,
            };
            var gettime = new Date();
            var queryparams1 =
              "affiliate=" +
              aff_id +
              "&cg_image_url=&mode=WAP&msisdn=" +
              conuty +
              phone +
              "&product_id=" +
              productdetails.product_id +
              "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2=" +
              otp;
            var veriftotpurlres =
              gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
            var finalobj5 = {
              security: "col#c4",
              logData: veriftotpurlres,
            };
            axios.post(myConfig.billing_url + "appLog.php", finalobj5);
            var createanotherurl =
              gettime +
              "|" +
              conuty +
              phone +
              "|" +
              window.location.pathname +
              "|" +
              1111 +
              "|" +
              browser +
              "|" +
              222222 +
              "|" +
              111111 +
              "|" +
              navigator.userAgent +
              "|" +
              otpurl +
              "|" +
              JSON.stringify(Response);
            var finalobj6 = {
              security: "col#c4",
              logData: createanotherurl,
            };
            axios.post(myConfig.billing_url + "visitorLog.php", finalobj6);

            if (Response.data.status == "OK") {
              // history.push('/thankYou')
              const result = axios(myConfig.server_url + "checkUser/" + conuty + phone, {
                headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
              }).then((res) => {
                console.log(res);
                if (res.data == false) {
                  var addsub = {
                    countryCode: conuty,
                    emailId: "string",
                    loginType: "mobile",
                    name: "",
                    phoneNumber: conuty + phone,
                    userId: conuty + phone,
                  };
                  axios
                    .post(myConfig.server_url + "user/", addsub, {
                      headers: {
                        Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                        "X-Content-Type-Options": "nosniff",
                      },
                    })
                    .then((Response) => {
                      window.sessionStorage.setItem("userId", conuty + phone);
                      $("#verify").hide();
                      $("#mobotp5").hide();
                      history.push("/welcome");
                    });
                } else {
                  const result = axios(myConfig.server_url + "getSubscribedUser/" + conuty + phone, {
                    headers: {
                      Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                      "X-Content-Type-Options": "nosniff",
                    },
                  }).then((resp) => {
                    window.sessionStorage.setItem("userId", conuty + phone);
                    localStorage.setItem("name", resp.data.name);
                    window.sessionStorage.setItem("isLogin", true);
                    $("#verify").hide();
                    $("#mobotp5").hide();
                    history.push("/welcome");
                  });
                }
              });
              // // return  console.log(result)
              //     $('#verify').hide()
              //     $("#mobotp").hide()
            } else {
              history.push("/fail");
            }
          });
        } else {
          $("#mobotp5").show();
        }
      } else {
        if (otp.length == 4) {
          var otpurl =
            virgin.test(window.location.pathname) == false || phones == ""
              ? myConfig.billing_url +
                "subscription.php?affiliate=" +
                aff_id +
                "&cg_image_url=&mode=WAP&msisdn=" +
                conuty +
                phone +
                "&product_id=" +
                productdetails.product_id +
                "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id=" +
                aff_id +
                "&camp_id=" +
                camp_id +
                "&other1=verify_otp&other2=" +
                otp
              : myConfig.billing_url +
                "subscription.php?affiliate=" +
                aff_id +
                "&cg_image_url=&mode=WAP&msisdn=" +
                phone +
                "&product_id=" +
                productdetails.product_id +
                "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2=" +
                otp;
          var queryparams =
            virgin.test(window.location.pathname) == false || phones == ""
              ? "affiliate = " +
                aff_id +
                " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
                conuty +
                phone +
                "| product_id = " +
                productdetails.product_id +
                "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 = verify_otp | other2 = " +
                otp
              : "affiliate = " +
                aff_id +
                " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
                phone +
                "| product_id = " +
                productdetails.product_id +
                "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 = verify_otp | other2 = " +
                otp;
          var gettime = new Date();
          var veriftotpurlreq =
            virgin.test(window.location.pathname) == false || phones == ""
              ? gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams
              : gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
          var finalobj9 = {
            security: "col#c4",
            logData: veriftotpurlreq,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj9);
          axios.get(otpurl).then((Response) => {
            var obj;
            if (virgin.test(window.location.pathname) == false || phones == "") {
              obj = {
                status: Response.data.status,
                ip: browser,
                agent: navigator.userAgent,
                response: Response,
                mobile_no: conuty + phone,
                productdetails: productdetails.product_id,
              };
            } else {
              obj = {
                status: Response.data.status,
                ip: browser,
                agent: navigator.userAgent,
                response: Response,
                mobile_no: phone,
                productdetails: productdetails.product_id,
              };
            }
            var obje = JSON.stringify(obj);
            var finalobj = {
              security: "col#c4",
              logData: obje,
            };
            var gettime = new Date();
            var queryparams1 =
              "affiliate=" +
              aff_id +
              "&cg_image_url=&mode=WAP&msisdn=" +
              conuty +
              phone +
              "&product_id=" +
              productdetails.product_id +
              "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2=" +
              otp;
            var veriftotpurlres =
              virgin.test(window.location.pathname) == false || phones == ""
                ? gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data)
                : gettime + "| RES |" + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
            var finalobj5 = {
              security: "col#c4",
              logData: veriftotpurlres,
            };
            axios.post(myConfig.billing_url + "appLog.php", finalobj5);
            var createanotherurl =
              virgin.test(window.location.pathname) == false || phones == ""
                ? gettime +
                  "|" +
                  conuty +
                  phone +
                  "|" +
                  window.location.pathname +
                  "|" +
                  1111 +
                  "|" +
                  browser +
                  "|" +
                  222222 +
                  "|" +
                  111111 +
                  "|" +
                  navigator.userAgent +
                  "|" +
                  otpurl +
                  "|" +
                  JSON.stringify(Response)
                : gettime +
                  "|" +
                  phone +
                  "|" +
                  window.location.pathname +
                  "|" +
                  1111 +
                  "|" +
                  browser +
                  "|" +
                  222222 +
                  "|" +
                  111111 +
                  "|" +
                  navigator.userAgent +
                  "|" +
                  otpurl +
                  "|" +
                  JSON.stringify(Response);
            var finalobj6 = {
              security: "col#c4",
              logData: createanotherurl,
            };
            axios.post(myConfig.billing_url + "visitorLog.php", finalobj6);

            if (Response.data.status == "OK") {
              // history.push('/thankYou')
              const result = axios(myConfig.server_url + "checkUser/" + conuty + phone, {
                headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
              }).then((res) => {
                console.log(res);
                if (res.data == false) {
                  var addsub = {
                    countryCode: conuty,
                    emailId: "string",
                    loginType: "mobile",
                    name: "",
                    phoneNumber: conuty + phone,
                    userId: conuty + phone,
                  };
                  axios
                    .post(myConfig.server_url + "user/", addsub, {
                      headers: {
                        Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                        "X-Content-Type-Options": "nosniff",
                      },
                    })
                    .then((Response) => {
                      window.sessionStorage.setItem("userId", conuty + phone);
                      $("#verify").hide();
                      $("#mobotp").hide();
                      history.push("/welcome");
                    });
                } else {
                  const result = axios(myConfig.server_url + "getSubscribedUser/" + conuty + phone, {
                    headers: {
                      Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                      "X-Content-Type-Options": "nosniff",
                    },
                  }).then((resp) => {
                    window.sessionStorage.setItem("userId", conuty + phone);
                    localStorage.setItem("name", resp.data.name);
                    window.sessionStorage.setItem("isLogin", true);
                    $("#verify").hide();
                    $("#mobotp").hide();
                    history.push("/welcome");
                  });
                }
              });
              // // return  console.log(result)
              //     $('#verify').hide()
              //     $("#mobotp").hide()
            } else {
              history.push("/fail");
            }
          });
        } else {
          $("#mobotp").show();
        }
      }
    } else {
      $("mobotp").show();
    }
  };

  const beline = () => {
    if (sierra.test(window.location.pathname) == true) {
      var gProductId = productdetails.product_id;
      var opcode = 91;
      if (orange.test(window.location.pathname) == true) {
        opcode = 91;
      } else {
        opcode = 100;
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      if (localStorage.getItem("plan") == "daily") {
        gProductId = "SEVdb100dly";
        //gProductId = "SEVdb100wly";
      } else {
        gProductId = "SEVdb100wly";
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var queryparams4 =
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var gettime = new Date();
      var subreq = gettime + "| REQ |" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
      var finalobj4 = {
        security: "col#c4",
        logData: subreq,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj4);
      axios.get(anotherUrl).then((Response) => {
        console.log(Response);
        /*** */
        var obj = {
          status: Response.data.status,
          ip: browser,
          agent: navigator.userAgent,
          response: Response,
          mobile_no: conuty + phone,
          productdetails: productdetails.product_id,
        };
        var obje = JSON.stringify(obj);
        var finalobj = {
          security: "col#c4",
          logData: obje,
        };
        var gettime = new Date();
        var queryparams5 =
          "subscription.php?affiliate=" +
          aff_id +
          "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
          productdetails.product_id +
          "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
        var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
        var finalobj7 = {
          security: "col#c4",
          logData: subros,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj7);
        var createanotherurl =
          gettime +
          "|" +
          conuty +
          phone +
          "|" +
          window.location.pathname +
          "|" +
          1111 +
          "|" +
          browser +
          "|" +
          222222 +
          "|" +
          111111 +
          "|" +
          navigator.userAgent +
          "|" +
          anotherUrl +
          "|" +
          JSON.stringify(Response);
        var finalobj8 = {
          security: "col#c4",
          logData: createanotherurl,
        };
        axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

        if (Response.data.status == "OK") {
          window.open(Response.data.url, "_blank");
          var getMsisdn =
            myConfig.billing_url +
            "subscription.php?affiliate=" +
            aff_id +
            "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
            gProductId +
            "&other1=fetchmsisdn&other2=2345&plan=" +
            localStorage.getItem("plan") +
            "&aff_id=" +
            aff_id +
            "&aff_uniq_id=" +
            click_id +
            "&camp_id=" +
            camp_id;
          axios.get(getMsisdn).then((MsisdnResponse) => {
            if (MsisdnResponse.data.code == "H900") {
              if (MsisdnResponse.data.msisdn) {
                var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(MsisdnResponse.data);
                var finalobj7 = {
                  security: "col#c4",
                  logData: subros,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj7);
                //call do billing api
                //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=SEVdb91baa&other1=do_billing&other2=&plan=daily&aff_id=1000&aff_uniq_id=1234&camp_id=3
                var doBilling =
                  myConfig.billing_url +
                  "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  MsisdnResponse.data.msisdn +
                  "&product_id=" +
                  gProductId +
                  "&other1=do_billing&other2=&plan=" +
                  localStorage.getItem("plan") +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id;
                console.log("doBilling:", doBilling);
                axios.get(doBilling).then((BillingResponse) => {
                  if (BillingResponse.data.status == "OK") {
                    window.sessionStorage.setItem("userId", conuty + MsisdnResponse.data.msisdn);
                    //localStorage.setItem("name",resp.data.name)
                    window.sessionStorage.setItem("isLogin", true);
                    $("#verify").hide();
                    $("#mobotp5").hide();
                    history.push("/welcome");
                    //window.location.href = redirectUrl
                  } else {
                    if (BillingResponse.data.code == "H101") {
                      history.push("/fail?code=subscribed");
                    } else if (BillingResponse.data.code == "H100") {
                      history.push("/fail?code=".BillingResponse.data.message);
                    } else {
                      history.push("/fail?code=");
                    }
                  }
                });
              } else {
                var errorRedirectUrl =
                  "https://osl.skysportsnetwork.com/sierra_leone/promo?plan=daily&aff_id=" +
                  aff_id +
                  "&click_id=" +
                  click_id +
                  "&wifi=yes&camp_id=" +
                  camp_id;
                //errorRedirectUrl =  encodeURIComponent(errorRedirectUrl)
                var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
                var finalobj10 = {
                  security: "col#c4",
                  logData: subrosSSS,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj10);

                var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
                //console.log(redirectUrl)
                //  alert(redirectUrl)
                window.location.href = errorRedirectUrl;
              }
            } else {
              var errorRedirectUrl =
                "https://osl.skysportsnetwork.com/sierra_leone/promo?plan=daily&aff_id=" +
                aff_id +
                "&click_id=" +
                click_id +
                "&wifi=yes&camp_id=" +
                camp_id;
              //errorRedirectUrl =  encodeURIComponent(errorRedirectUrl)
              var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
              var finalobj10 = {
                security: "col#c4",
                logData: subrosSSS,
              };
              axios.post(myConfig.billing_url + "appLog.php", finalobj10);

              var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
              //console.log(redirectUrl)
              //  alert(redirectUrl)
              window.location.href = errorRedirectUrl;
            }
          });
        } else {
          if (Response.data.code == "H101") {
            history.push("/fail?code=subscribed");
          } else if (Response.data.code == "H100") {
            history.push("/fail?code=inSufBal");
          } else {
            history.push("/fail?code=");
          }

          // window.location.href = '/fail'
        }
      });
      /* //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=SEVdb91baa&other1=&other2=&plan=daily&aff_id=1000&aff_uniq_id=1234&camp_id=3
      var anotherUrl = myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&cg_image_url=&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=&other2=&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
      var queryparams4 = "subscription.php?affiliate="+aff_id+"&cg_image_url=&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
      var gettime = new Date();
      var subreq = gettime + '| REQ |' + myConfig.billing_url+"subscription.php" + '| POST Parameters =>' + queryparams4
      var finalobj4 = {
        security : "col#c4",
        logData : subreq
      }
      //
      axios.post(myConfig.billing_url+"appLog.php",finalobj4)
      axios.get(anotherUrl)
      .then(Response => {
        if(Response.data.status=="OK"){
          var redirectUrl = Response.data.url;
          var transactionId = Response.data.trans_id;  
         // window.location.href = redirectUrl
         //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&msisdn=9000000000&product_id=SEVdb91baa&camp_id=3&other1=fetchmsisdn&other2=2022120808421210000000009856&OPID
         var finalobj4 = {
          security : "col#c4",
          logData : Response.data
        }
        axios.post(myConfig.billing_url+"appLog.php",finalobj4)
        var anotherUrl = myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=fetchmsisdn&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
        var queryparams4 = "subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=fetchmsisdn&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
        var gettime = new Date();
        var subreq = gettime + '| REQ |' + myConfig.billing_url+"subscription.php" + '| POST Parameters =>' + queryparams4
        var finalobj4 = {
          security : "col#c4",
          logData : subreq
        }
        axios.post(myConfig.billing_url+"appLog.php",finalobj4)
        axios.post(anotherUrl)
        .then(res=>{
            console.log(res)
            // start work 
            //sattus = OK 
            if(res.data.status == 'OK') {

            var opsUrl = myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=do_billing&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
            var queryparamsOps = "subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=do_billing&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
            var gettime = new Date();
            var subreq = gettime + '| REQ |' + myConfig.billing_url+"subscription.php" + '| POST Parameters =>' + queryparamsOps
            var finalobjOps = {
              security : "col#c4",
              logData : opsUrl
            }
            axios.post(myConfig.billing_url+"appLog.php",finalobjOps)
          }
        })
           
        }else{
          if (Response.data.code == 'H101') {
            history.push('/fail?code=subscribed')
          }else if(Response.data.code == 'H100'){
            history.push('/fail?code=inSufBal')
          }else{
            history.push('/fail?code=')
          }
        }
       
         
      })*/
    } else if (orange.test(window.location.pathname) == true) {
      var gProductId = productdetails.product_id;
      var opcode = 91;
      if (orange.test(window.location.pathname) == true) {
        opcode = 91;
      } else {
        opcode = 100;
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      if (localStorage.getItem("plan") == "daily" && gProductId == "SEVdb1gp") {
        gProductId = "SEVdb2gp";
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var queryparams4 =
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var gettime = new Date();
      var subreq = gettime + "| REQ |" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
      var finalobj4 = {
        security: "col#c4",
        logData: subreq,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj4);
      axios.get(anotherUrl).then((Response) => {
        var obj = {
          status: Response.data.status,
          ip: browser,
          agent: navigator.userAgent,
          response: Response,
          mobile_no: conuty + phone,
          productdetails: productdetails.product_id,
        };
        var obje = JSON.stringify(obj);
        var finalobj = {
          security: "col#c4",
          logData: obje,
        };
        var gettime = new Date();
        var queryparams5 =
          "subscription.php?affiliate=" +
          aff_id +
          "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
          productdetails.product_id +
          "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
        var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
        var finalobj7 = {
          security: "col#c4",
          logData: subros,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj7);
        var createanotherurl =
          gettime +
          "|" +
          conuty +
          phone +
          "|" +
          window.location.pathname +
          "|" +
          1111 +
          "|" +
          browser +
          "|" +
          222222 +
          "|" +
          111111 +
          "|" +
          navigator.userAgent +
          "|" +
          anotherUrl +
          "|" +
          JSON.stringify(Response);
        var finalobj8 = {
          security: "col#c4",
          logData: createanotherurl,
        };
        axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

        if (Response.data.status == "OK") {
          window.open(Response.data.url, "_blank");
          var getMsisdn =
            myConfig.billing_url +
            "subscription.php?affiliate=" +
            aff_id +
            "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
            gProductId +
            "&other1=fetchmsisdn&other2=2345&plan=" +
            localStorage.getItem("plan") +
            "&aff_id=" +
            aff_id +
            "&aff_uniq_id=" +
            click_id +
            "&camp_id=" +
            camp_id;
          console.log(getMsisdn);
          axios.get(getMsisdn).then((MsisdnResponse) => {
            if (MsisdnResponse.data.code == "H900") {
              if (MsisdnResponse.data.msisdn) {
                //call do billing api
                //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=SEVdb91baa&other1=do_billing&other2=&plan=daily&aff_id=1000&aff_uniq_id=1234&camp_id=3
                var doBilling =
                  myConfig.billing_url +
                  "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  MsisdnResponse.data.msisdn +
                  "&product_id=" +
                  gProductId +
                  "&other1=do_billing&other2=&plan=" +
                  localStorage.getItem("plan") +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id;
                console.log("doBilling:", doBilling);
                var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(MsisdnResponse.data);
                var finalobj7 = {
                  security: "col#c4",
                  logData: subros,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj7);
                axios.get(doBilling);
                console.log("doBilling:", doBilling).then((BillingResponse) => {
                  console.log(BillingResponse);
                  if (BillingResponse.data.status == "OK") {
                    window.sessionStorage.setItem("userId", conuty + MsisdnResponse.data.msisdn);
                    //localStorage.setItem("name",resp.data.name)
                    window.sessionStorage.setItem("isLogin", true);
                    $("#verify").hide();
                    $("#mobotp5").hide();
                    history.push("/welcome");
                  } else {
                    if (BillingResponse.data.code == "H101") {
                      history.push("/fail?code=subscribed");
                    } else if (BillingResponse.data.code == "H100") {
                      history.push("/fail?code=".BillingResponse.data.message);
                    } else {
                      history.push("/fail?code=");
                    }
                  }
                });
              } else {
                var errorRedirectUrl =
                  "https://op.skysportsnetwork.com/orange_poland/promo?plan=daily&aff_id=" +
                  aff_id +
                  "&click_id=" +
                  click_id +
                  "&wifi=yes&camp_id=" +
                  camp_id;
                errorRedirectUrl = encodeURIComponent(errorRedirectUrl);
                var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
                var finalobj10 = {
                  security: "col#c4",
                  logData: subrosSSS,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj10);

                var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
                //console.log(redirectUrl)
                //  alert(redirectUrl)
                window.location.href = redirectUrl;
              }
            } else {
              var errorRedirectUrl =
                "https://op.skysportsnetwork.com/orange_poland/promo?plan=daily&aff_id=" +
                aff_id +
                "&click_id=" +
                click_id +
                "&wifi=yes&camp_id=" +
                camp_id;
              errorRedirectUrl = encodeURIComponent(errorRedirectUrl);
              var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
              var finalobj10 = {
                security: "col#c4",
                logData: subrosSSS,
              };
              axios.post(myConfig.billing_url + "appLog.php", finalobj10);

              var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
              //console.log(redirectUrl)
              //  alert(redirectUrl)
              window.location.href = redirectUrl;
            }
          });
        } else {
          if (Response.data.code == "H101") {
            history.push("/fail?code=subscribed");
          } else if (Response.data.code == "H100") {
            history.push("/fail?code=inSufBal");
          } else {
            history.push("/fail?code=");
          }

          // window.location.href = '/fail'
        }
      });
    } else {
      var gProductId = productdetails.product_id;
      if (camp_id === NaN) {
        camp_id = 3;
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      if (localStorage.getItem("plan") == "daily" && gProductId == "SEVdb1gp") {
        gProductId = "SEVdb2gp";
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var queryparams4 =
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var gettime = new Date();
      var subreq = gettime + "| REQ |" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
      var finalobj4 = {
        security: "col#c4",
        logData: subreq,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj4);
      axios.get(anotherUrl).then((Response) => {
        var obj = {
          status: Response.data.status,
          ip: browser,
          agent: navigator.userAgent,
          response: Response,
          mobile_no: conuty + phone,
          productdetails: productdetails.product_id,
        };
        var obje = JSON.stringify(obj);
        var finalobj = {
          security: "col#c4",
          logData: obje,
        };
        var gettime = new Date();
        var queryparams5 =
          "subscription.php?affiliate=" +
          aff_id +
          "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
          productdetails.product_id +
          "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
        var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
        var finalobj7 = {
          security: "col#c4",
          logData: subros,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj7);
        var createanotherurl =
          gettime +
          "|" +
          conuty +
          phone +
          "|" +
          window.location.pathname +
          "|" +
          1111 +
          "|" +
          browser +
          "|" +
          222222 +
          "|" +
          111111 +
          "|" +
          navigator.userAgent +
          "|" +
          anotherUrl +
          "|" +
          JSON.stringify(Response);
        var finalobj8 = {
          security: "col#c4",
          logData: createanotherurl,
        };
        axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

        if (Response.data.status == "OK") {
          // var url = new URL(Response.data.url)
          // var get_tx_id = url.searchParams.get("partner_txid")
          // console.log("get_tx_id",get_tx_id);
          // var search_params = url.searchParams;
          // search_params.set('partner_txid', get_tx_id +"_"+aff_id+"_"+click_id);
          // url.search = search_params.toString();
          // var new_url = url.toString();
          // console.log(new_url);
          // Response.data.url = new_url
          var errorRedirectUrl =
            "https://bg.skysportsnetwork.com/beeline_georgia/promo?plan=daily&aff_id=" +
            aff_id +
            "&click_id=" +
            click_id +
            "&wifi=yes&camp_id=" +
            camp_id;
          errorRedirectUrl = encodeURIComponent(errorRedirectUrl);
          var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
          var finalobj10 = {
            security: "col#c4",
            logData: subrosSSS,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj10);

          var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
          //console.log(redirectUrl)
          //  alert(redirectUrl)
          window.location.href = redirectUrl;
        } else {
          if (Response.data.code == "H101") {
            history.push("/fail?code=subscribed");
          } else if (Response.data.code == "H100") {
            history.push("/fail?code=inSufBal");
          } else {
            history.push("/fail?code=");
          }

          // window.location.href = '/fail'
        }
      });
    }
  };

  const sendotp = () => {
    if (isSmsFlow) {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);

      console.log("Open Messag App");
      var phoneNumber = "802054";
      var message = "1";
      var smsUrl = "";
      if (isIOS) {
        smsUrl = "sms:" + phoneNumber + "&body=" + encodeURIComponent(message);
        window.location.href = smsUrl;
      } else if (isAndroid) {
        smsUrl = "sms:" + phoneNumber + "?body=" + encodeURIComponent(message);
        window.location.href = smsUrl;
      } else {
        alert("We are unable to send message");
      }

      return;
    }
    var dial_code = window.sessionStorage.getItem("dialCode");
    window.sessionStorage.setItem("userId", conuty + phone);
    if (phone != "undefined") {
      if (phone.length > 0) {
        var url =
          virgin.test(window.location.pathname) == false || phones == ""
            ? myConfig.billing_url + "checkSubscription.php?msisdn=" + conuty + phone+"&operator_id=246"
            : myConfig.billing_url + "checkSubscription.php?msisdn=" + phone+"&operator_id=246";
        var queryparams2 =
          virgin.test(window.location.pathname) == false || phones == ""
            ? "msisdn=" + conuty + phone + " | product_id=" + productdetails.product_id
            : "msisdn=" + phone + " | product_id=" + productdetails.product_id;
        var gettime = new Date();
        var phoneotpurlreq =
          virgin.test(window.location.pathname) == false || phones == ""
            ? gettime + "| REQ |" + conuty + phone + "| operator_id=246 | " + myConfig.billing_url + "checkSubscription.php" + "| Post Parameter =>" + queryparams2
            : gettime + "| REQ |" + phone + "| operator_id=246 | " + myConfig.billing_url + "checkSubscription.php" + "| Post Parameter =>" + queryparams2;
        var finalobj1 = {
          security: "col#c4",
          logData: phoneotpurlreq,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj1);
        axios.get(url).then((Response) => {
          var obj;
          if (virgin.test(window.location.pathname) == false || phones == "") {
            obj = {
              status: Response.data.status,
              ip: browser,
              agent: navigator.userAgent,
              response: Response,
              mobile_no: conuty + phone,
              productdetails: productdetails.product_id,
            };
          } else {
            obj = {
              status: Response.data.status,
              ip: browser,
              agent: navigator.userAgent,
              response: Response,
              mobile_no: phone,
              productdetails: productdetails.product_id,
            };
          }
          var obje = JSON.stringify(obj);
          var finalobj = {
            security: "col#c4",
            logData: obje,
          };
          var gettime = new Date();
          
          var phoneotpurlres =
            virgin.test(window.location.pathname) == false || phones == ""
              ? gettime + "| RES |" + conuty + phone + " | operator_id=246 |" + myConfig.billing_url + "checkSubscription.php" + "|" + JSON.stringify(Response.data)
              : gettime + "| RES |" + phone + " | operator_id=246 |" + myConfig.billing_url + "checkSubscription.php" + "|" + JSON.stringify(Response.data);
          var finalobj2 = {
            security: "col#c4",
            logData: phoneotpurlres,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj2);
          var createurl =
            virgin.test(window.location.pathname) == false || phones == ""
              ? gettime +
                "|" +
                conuty +
                phone +
                "|" +
                window.location.pathname +
                "|" +
                1111 +
                "|" +
                browser +
                "|" +
                222222 +
                "|" +
                111111 +
                "|" +
                navigator.userAgent +
                "|" +
                url +
                "|" +
                JSON.stringify(Response)
              : gettime +
                "|" +
                phone +
                "|" +
                window.location.pathname +
                "|" +
                1111 +
                "|" +
                browser +
                "|" +
                222222 +
                "|" +
                111111 +
                "|" +
                navigator.userAgent +
                "|" +
                url +
                "|" +
                JSON.stringify(Response);
          var finalobj3 = {
            security: "col#c4",
            logData: createurl,
          };
          axios.post(myConfig.billing_url + "visitorLog.php", finalobj3);

          if (Response.data.status != "success") {
            var anotherUrl =
              virgin.test(window.location.pathname) == false || phones == ""
                ? myConfig.billing_url +
                  "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  conuty +
                  phone +
                  "&product_id=" +
                  productdetails.product_id +
                  "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
                  plan +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id
                : myConfig.billing_url +
                  "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  phone +
                  "&product_id=" +
                  productdetails.product_id +
                  "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
                  plan +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id;
            var queryparams4 =
              virgin.test(window.location.pathname) == false || phones == ""
                ? "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  conuty +
                  phone +
                  "&product_id=" +
                  productdetails.product_id +
                  "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
                  plan +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id
                : "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  phone +
                  "&product_id=" +
                  productdetails.product_id +
                  "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
                  plan +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id;
            var gettime = new Date();
            var subreq =
              virgin.test(window.location.pathname) == false || phones == ""
                ? gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4
                : gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
            var finalobj4 = {
              security: "col#c4",
              logData: subreq,
            };
            axios.post(myConfig.billing_url + "appLog.php", finalobj4);
            axios.get(anotherUrl).then((Response) => {
              var obj;
              if (virgin.test(window.location.pathname) == false || phones == "") {
                obj = {
                  status: Response.data.status,
                  ip: browser,
                  agent: navigator.userAgent,
                  response: Response,
                  mobile_no: conuty + phone,
                  productdetails: productdetails.product_id,
                };
              } else {
                obj = {
                  status: Response.data.status,
                  ip: browser,
                  agent: navigator.userAgent,
                  response: Response,
                  mobile_no: phone,
                  productdetails: productdetails.product_id,
                };
              }
              var obje = JSON.stringify(obj);
              var finalobj = {
                security: "col#c4",
                logData: obje,
              };
              var gettime = new Date();
              var queryparams5 =
                "subscription.php?affiliate=" +
                aff_id +
                "&cg_image_url=&mode=WAP&msisdn=" +
                conuty +
                phone +
                "&product_id=" +
                productdetails.product_id +
                "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
              var subros =
                virgin.test(window.location.pathname) == false || phones == ""
                  ? gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data)
                  : gettime + "| RES |" + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
              var finalobj7 = {
                security: "col#c4",
                logData: subros,
              };
              axios.post(myConfig.billing_url + "appLog.php", finalobj7);
              var createanotherurl =
                virgin.test(window.location.pathname) == false || phones == ""
                  ? gettime +
                    "|" +
                    conuty +
                    phone +
                    "|" +
                    window.location.pathname +
                    "|" +
                    1111 +
                    "|" +
                    browser +
                    "|" +
                    222222 +
                    "|" +
                    111111 +
                    "|" +
                    navigator.userAgent +
                    "|" +
                    anotherUrl +
                    "|" +
                    JSON.stringify(Response)
                  : gettime +
                    "|" +
                    phone +
                    "|" +
                    window.location.pathname +
                    "|" +
                    1111 +
                    "|" +
                    browser +
                    "|" +
                    222222 +
                    "|" +
                    111111 +
                    "|" +
                    navigator.userAgent +
                    "|" +
                    anotherUrl +
                    "|" +
                    JSON.stringify(Response);
              var finalobj8 = {
                security: "col#c4",
                logData: createanotherurl,
              };
              axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

              if (Response.data.status == "OK") {
                $("#verify").show();
                $("#subscribeMsisdn").hide();
              } else {
                history.push("/fail");
                // window.location.href = '/fail'
              }
            });
          } else {
            window.location.href = "/welcome";
          }
        });

        axios.post(myConfig.billing_url + "stagingCount.php?aff_id=" + aff_id + "&operator_id=" + operator_id + "&click_submit_count=1");
        var veriftotpurlreq =
          gettime +
          "| REQ |" +
          myConfig.billing_url +
          "stagingCount.php" +
          "| POST Parameters =>" +
          "aff_id=" +
          aff_id +
          "&operator_id=" +
          operator_id +
          "&click_submit_count=1";
        var finalobj22 = {
          security: "col#c4",
          logData: veriftotpurlreq,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj22);

        $("#mob").hide();
      } else {
        console.log("in");
        $("#mob").show();
      }
    } else {
    }
  };

  const Exit = () => {
    window.location.href = "/";
  };

  const completecgflow = () => {
    var str = window.location.pathname;
    const dataes = codeJson.filter((i) => i.link === str);
    var otpurl =
      myConfig.billing_url +
      "subscription.php?affiliate=" +
      aff_id +
      "&cg_image_url=&mode=WAP&msisdn=" +
      phone +
      "&product_id=" +
      dataes[0].product_id +
      "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
      plan +
      "&aff_id=" +
      aff_id +
      "&aff_uniq_id=" +
      click_id +
      "&camp_id=" +
      camp_id;
    var queryparams =
      "affiliate = " +
      aff_id +
      " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
      phone +
      "| product_id = " +
      dataes[0].product_id +
      "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 =  | other2 = &plan=" +
      plan +
      "&aff_id=" +
      aff_id +
      "&aff_uniq_id=" +
      click_id +
      "&camp_id=" +
      camp_id;
    var gettime = new Date();
    var veriftotpurlreq = gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
    var finalobj9 = {
      security: "col#c4",
      logData: veriftotpurlreq,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj9);
    axios.get(otpurl).then((Response) => {
      var obj = {
        status: Response.data.status,
        ip: browser,
        agent: navigator.userAgent,
        response: Response,
        mobile_no: phone,
        productdetails: dataes[0].product_id,
      };
      var obje = JSON.stringify(obj);
      var finalobj = {
        security: "col#c4",
        logData: obje,
      };
      var gettime = new Date();
      var queryparams1 =
        "affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=" +
        phone +
        "&product_id=" +
        dataes[0].product_id +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=";
      var veriftotpurlres = gettime + "| RES |" + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
      var finalobj5 = {
        security: "col#c4",
        logData: veriftotpurlres,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj5);
      var createanotherurl =
        gettime +
        "|" +
        phone +
        "|" +
        window.location.pathname +
        "|" +
        1111 +
        "|" +
        browser +
        "|" +
        222222 +
        "|" +
        111111 +
        "|" +
        navigator.userAgent +
        "|" +
        otpurl +
        "|" +
        JSON.stringify(Response);
      var finalobj6 = {
        security: "col#c4",
        logData: createanotherurl,
      };
      axios.post(myConfig.billing_url + "visitorLog.php", finalobj6);

      if (Response.data.status == "OK") {
        // history.push('/thankYou')
        // const result = axios(
        //   myConfig.server_url+'checkUser/'+phone,
        //   {headers:{"Authorization":"Basic "+Buffer.from(`${myConfig.user}:${myConfig.password}`, 'utf8').toString('base64')}}
        // ).then(res => {
        //   console.log(res)
        //   if (res.data == false) {
        //           var addsub = {
        //               "countryCode": conuty,
        //               "emailId": "string",
        //               "loginType": "mobile",
        //               "name": "",
        //               "phoneNumber": phone,
        //               "userId": phone
        //           }
        //           axios.post(myConfig.server_url+"user/",addsub,{headers:{"Authorization":"Basic "+Buffer.from(`${myConfig.user}:${myConfig.password}`, 'utf8').toString('base64'),"X-Content-Type-Options": "nosniff"}})
        //           .then(Response => {
        //               window.sessionStorage.setItem("userId", phone);
        //               $('#verify').hide()
        //               $("#mobotp").hide()
        //               history.push('/welcome')
        //           })
        //       }else {
        //           const result = axios(
        //               myConfig.server_url+'getSubscribedUser/'+phone,
        //               {headers:{"Authorization":"Basic "+Buffer.from(`${myConfig.user}:${myConfig.password}`, 'utf8').toString('base64'),"X-Content-Type-Options": "nosniff"}}
        //             ).then(resp => {
        //               window.sessionStorage.setItem("userId", phone);
        //               localStorage.setItem("name",resp.data.name)
        //               window.sessionStorage.setItem("isLogin", true);
        //               $('#verify').hide()
        //               $("#mobotp").hide()
        //               history.push('/')
        //             })
        //       }
        // })
        // // return  console.log(result)
        //     $('#verify').hide()
        //     $("#mobotp").hide()
        window.location.href = Response.data.url;
      } else {
        history.push("/fail");
      }
    });
  };

  const completecheckflow = () => {
    var str = window.location.pathname;
    var otpurl =
      myConfig.redirect_url +
      "ConsentGateway/queryMsisdn?vendorId=IBUDigitalLtd159&serviceId=" +
      service_no +
      "&tid=TN_SSN_" +
      aff_id +
      "_" +
      click_id +
      "_" +
      camp_id +
      "_" +
      Math.floor(1000 + Math.random() * 9000) +
      "_" +
      new Date().getTime();
    var queryparams =
      "vendorid=IBUDigitalLtd159=&serviceId=" +
      service_no +
      "tid=TN_SSN_" +
      aff_id +
      "_" +
      click_id +
      "_" +
      camp_id +
      "_" +
      Math.floor(1000 + Math.random() * 9000) +
      new Date().getTime();
    var gettime = new Date();
    var veriftotpurlreq = gettime + "| REQ |" + myConfig.redirect_url + "ConsentGateway/queryMsisdn" + "| POST Parameters =>" + queryparams;
    var finalobj9 = {
      security: "col#c4",
      logData: veriftotpurlreq,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj9);
    axios.post(myConfig.billing_url + "stagingCount.php?aff_id=" + aff_id + "&operator_id=" + operator_id + "&click_submit_count=1");
    var veriftotpurlreqs =
      gettime +
      "| REQ |" +
      myConfig.billing_url +
      "stagingCount.php" +
      "| POST Parameters =>" +
      "aff_id=" +
      aff_id +
      "&operator_id=" +
      operator_id +
      "&click_submit_count=1";
    var finalobj22 = {
      security: "col#c4",
      logData: veriftotpurlreqs,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj22);
    window.location.href = otpurl;
  };

  return (
    <div style={{ flex: "1" }} className={uae.test(window.location.pathname) == true ? "landingPageNew" : "landingPage"}>
      <div className="container">
        <div className="row">
          {cgflow == false ? (
            checkflow == true ? (
              <>
                {localStorage.getItem("bmsisdn") == "undefined" ||
                localStorage.getItem("bmsisdn") == undefined ||
                localStorage.getItem("bmsisdn") == null ? (
                  <div className="col">
                    <div className="heading">{lan.product_name}</div>
                    {/* <div className="subheading">
                      {lan.tosubscribe}
                      <span>{localStorage.getItem("plan") == "daily" ? lan.aoc : lan.aocweekly}</span>
                    </div> */}
                    <div className="link" id="subscribeMsisdn">
                      <a
                        id="msisdn"
                        className="buttondis"
                        style={{ marginTop: "30px", cursor: "pointer" }}
                        onClick={
                          beeline.test(window.location.pathname) == true ||
                          grameen.test(window.location.pathname) == true ||
                          orange.test(window.location.pathname) == true ||
                          sierra.test(window.location.pathname) == true
                            ? beline
                            : completecheckflow
                        }>
                        {lan.subscribe}
                      </a>
                      <br></br>
                      <a
                        id="msisdn1"
                        className="buttondis"
                        style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                        onClick={Exit}>
                        {lan.lwelexit}
                      </a>
                    </div>
                    <br></br>
                    {localStorage.getItem("lang") == "boar" ? (
                      <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}>წესები და პირობები</div>
                    ) : (
                      <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}>
                        Terms and Conditions
                      </div>
                    )}

                    <div className={localStorage.getItem("lang") == "ar" ? "termsData arabicTermData" : "termsData"}>
                      <ul
                        style={
                          localStorage.getItem("lang") == "ar"
                            ? { paddingLeft: "20px", paddingRight: "20px", textAlign: "right", direction: "rtl" }
                            : { paddingLeft: "20px", paddingRight: "20px", textAlign: "left" }
                        }>
                        {localStorage.getItem("plan") == "daily" ||
                        localStorage.getItem("plan") == "null" ||
                        localStorage.getItem("plan") == undefined ? (
                          <>
                            {lan.terms === undefined
                              ? ""
                              : lan.terms.split("\n").map((str) => (
                                  <>
                                    <li>
                                      <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                    </li>
                                  </>
                                ))}{" "}
                            <br></br>
                            {lan.lwelcometermsbr === undefined
                              ? ""
                              : lan.lwelcometermsbr.split("\n").map((str) => (
                                  <>
                                    <li>
                                      <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                    </li>
                                  </>
                                ))}
                          </>
                        ) : (
                          lan.termsweekly.split("\n").map((str) => (
                            <>
                              <li>
                                <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                              </li>
                            </>
                          ))
                        )}{" "}
                      </ul>
                      <a href="/tnc">click here</a>
                    </div>
                  </div>
                ) : (
                  <div>
                    {/* code for page popup*/}
                    <div className="col">
                      {localStorage.getItem("lang") == "boar" ? (
                        <div className="subheading" style={{ fontSize: "1.2rem" }}>
                          ნომრის {localStorage.getItem("bmsisdn")} ბალანსიდან ყოველდღე ჩამოიჭრება სერვისის საფასური 2 ₾. ადასტურებ სერვისის
                          აქტივაციას?
                        </div>
                      ) : (
                        <div className="subheading" style={{ fontSize: "1.2rem" }}>
                          A service fee of 2 ₾ will be deducted from the balance of number {localStorage.getItem("bmsisdn")} every day. Confirm
                          service activation?
                        </div>
                      )}
                      <div className="link" id="subscribeMsisdn">
                        <a id="msisdn" className="buttondis" style={{ marginTop: "30px", cursor: "pointer", width: "130px" }} onClick={subConfirm}>
                          {lan.ok}
                        </a>
                        <a
                          id="msisdn1"
                          className="buttondis"
                          style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                          onClick={callCancel}>
                          {lan.cancel}
                        </a>
                      </div>
                      <br></br>
                      {localStorage.getItem("lang") == "boar" ? (
                        <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}>
                          წესები და პირობები
                        </div>
                      ) : (
                        <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}>
                          Terms and Conditions
                        </div>
                      )}

                      <div
                        className={localStorage.getItem("lang") == "ar" ? "termsData arabicTermData" : "termsData"}
                        content="text/html;charset=utf-8">
                        <ul
                          style={
                            localStorage.getItem("lang") == "ar"
                              ? { paddingLeft: "20px", paddingRight: "20px", textAlign: "right", direction: "rtl" }
                              : { paddingLeft: "20px", paddingRight: "20px", textAlign: "left" }
                          }>
                          {localStorage.getItem("plan") == "daily"
                            ? lan.terms === undefined
                              ? ""
                              : lan.terms.split("\n").map((str) => (
                                  <>
                                    <li>
                                      <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                    </li>
                                  </>
                                ))
                            : lan.termsweekly === undefined
                            ? ""
                            : lan.termsweekly.split("\n").map((str) => (
                                <>
                                  <li>
                                    <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                  </li>
                                </>
                              ))}{" "}
                        </ul>
                        <a href="/tnc">click here</a>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="col">
                {isSmsFlow ? <div className="heading">{lan.product_name}</div> : <></>}
                {isSmsFlow ? (
                  <div>
                    <img style={{ width: "20%" }} src="/asset/images/imagelanding.png" />
                  </div>
                ) : (
                  <></>
                )}

                <div className="subheading">
                 
                  {isSmsFlow?lan.smsFlowSubscribeCotent1:""}

                  {/* <span>{localStorage.getItem("plan") == "daily" ? lan.aoc : lan.aocweekly}</span> */}
                </div>

                <div className="link" id="subscribeMsisdn">
                  {/* <div className="subheading">{lan.otp}</div> */}

                  {(virgin.test(window.location.pathname) == false || phones == "") && isSmsFlow == false ? (
                    <input className="subscribeText1" type="text" value={conutys} readOnly />
                  ) : (
                    ""
                  )}
                  {isSmsFlow ? (
                    <></>
                  ) : (
                    <input
                      className="subscribeText"
                      onChange={checknumber}
                      type="text"
                      value={phone}
                      placeholder={lan.enterotp}
                      id="phoneNoSub"
                      pattern="\d*"
                    />
                  )}
                  <div
                    id="mob"
                    style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}></div>
                  <br></br>
                  <div className="btnSection">
                    <a
                      id="msisdn"
                      className={isSmsFlow ? "buttondis smsFlowButton" : "buttondis"}
                      style={isSmsFlow ?{  marginTop: "0px", cursor: "pointer" } :{  marginTop: "20px", cursor: "pointer" }}
                      onClick={sendotp}>
                      {isSmsFlow ? (
                        <>
                          {lan.subscribeBtnSMS1} 
                        </>
                      ) : (
                        lan.subscribe
                      )}
                    </a>
                    {isSmsFlow ? (
                      <></>
                    ) : (
                      <a
                        id="msisdn1"
                        className="buttondis"
                        style={{ marginTop: "20px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                        onClick={Exit}>
                        {lan.lwelexit}
                      </a>
                    )}
                  </div>
                  <br></br>
                  <p dir={localStorage.getItem("lang") === "ar" ? "rtl" : "ltr"}>{isSmsFlow? lan.aoc:''}</p>
                  <p dir={localStorage.getItem("lang") === "ar" ? "rtl" : "ltr"}>{isSmsFlow? "":lan.afterClick}</p>
              

                  <br></br>
                  <p dir={localStorage.getItem("lang") == "ar" ? "rtl" : "ltr"}>{isSmsFlow? "":lan.lwelcome}</p>
                </div>

                <div className="link" id="verify">
                  <h4 style={{ marginBottom: "18px", fontSize: "19px", fontWeight: "800" }}>{lan.lwelcomeenterotp}</h4>
                  <input className="subscribeText" type="text" onChange={checkotp} placeholder="Enter OTP" id="otpSub" pattern="\d*" maxlength="6" />
                  <div
                    id="mobotp"
                    style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}>
                    Please Enter 4 Digit Valid Otp
                  </div>
                  <div
                    id="mobotp5"
                    style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}>
                    Please Enter 5 Digit Valid Otp
                  </div>
                  <br></br>
                  <a id="verifyBtn" className="buttondis" style={{ marginTop: "30px", cursor: "pointer" }} onClick={verifyotp}>
                    {lan.lwelcomeconform}
                  </a>
                  <br></br>
                  <a
                    id="msisdn2"
                    className="buttondis"
                    style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                    onClick={Exit}>
                    {lan.lwelexit}
                  </a>
                </div>
                <br></br>

                {tmobile.test(window.location.pathname) == true ||
                play.test(window.location.pathname) == true ||
                plus.test(window.location.pathname) == true ? (
                  <div style={{ margin: "0% 40%" }}>
                    <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"} style={{ float: "left" }}>
                      Zasady i warunki:
                    </div>
                    <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"} style={{ float: "left" }}>
                      <a href="/tnc">Kliknij tutaj</a>
                    </div>
                  </div>
                ) : (
                  <>
                    {
                    isSmsFlow ? 
                    <></>:
                    localStorage.getItem("lang") == "boar" ? (
                      <div className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}>წესები და პირობები</div>
                    ) : localStorage.getItem("lang") == "ar" ? (
                      <div
                        className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}
                        style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>
                        البنود والظروف
                      </div>
                    ) : (
                      <div
                        className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}
                        style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>
                        Terms & Conditions
                      </div>
                    )}

                    <div className={localStorage.getItem("lang") == "ar" ? "termsData arabicTermData" : "termsData"}>
                      <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}> {isSmsFlow ?  "":lan.byClick}</p>
                      <ul
                        style={
                          localStorage.getItem("lang") == "ar"
                            ? { paddingLeft: "20px", paddingRight: "20px", textAlign: "right", direction: "rtl" }
                            : { paddingLeft: "20px", paddingRight: "20px", textAlign: "left" }
                        }>
                        {isSmsFlow?<><p style={{textAlign:"center"}}>{lan.subscribeBtnSMS4}</p><br/><p style={{textAlign:"center"}}>  {lan.subscribeBtnSMS3} </p> </>:
                        
                        
                        localStorage.getItem("plan") == "daily" ||
                        localStorage.getItem("plan") == "null" ||
                        localStorage.getItem("plan") == undefined
                          ? lan.terms === undefined
                            ? ""
                            : lan.terms.split("\n").map((str, index) => {
                                console.log(index);
                                console.log(lan.terms.split("\n").length);
                                if (index == lan.terms.split("\n").length - 1) {
                                  return (
                                    <li>
                                      <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>
                                        {str} <a href="/tnc">click here</a>
                                      </p>
                                    </li>
                                  );
                                }
                                return (
                                  <li>
                                    <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                  </li>
                                );
                              })
                          : lan.termsweekly === undefined
                          ? ""
                          : lan.termsweekly.split("\n").map((str) => (
                              <>
                                <li>
                                  <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                </li>
                              </>
                            ))}
                        {lan.lwelcometermsbr === undefined ? "" : lan.lwelcometermsbr.split("\n").map((str) => <></>)}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            )
          ) : (
            <>
              {show1 == true ? (
                <div className="col">
                  <div className="heading">{lan.product_name}</div>
                  <div className="subheading">
                    {lan.tosubscribe}
                    <span>{localStorage.getItem("plan") == "daily" ? lan.aoc : lan.aocweekly}</span>
                  </div>
                  <div className="link" id="subscribeMsisdn">
                    <a id="msisdn" className="buttondis" style={{ marginTop: "30px", cursor: "pointer" }} onClick={completecgflow}>
                      {lan.lwelcomeconform}
                    </a>
                    <br></br>
                    <a
                      id="msisdn1"
                      className="buttondis"
                      style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                      onClick={Exit}>
                      {lan.lwelCancel}
                    </a>
                  </div>
                  <br></br>
                  {JSON.stringify(lan)}
                  {localStorage.getItem("lang") == "ar" ? (
                    <div
                      className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}
                      style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>
                      البنود و الظروف
                    </div>
                  ) : (
                    <div
                      className={localStorage.getItem("lang") == "ar" ? "termsHeading arabicTermData" : "termsHeading"}
                      style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>
                      Terms and Conditions:
                    </div>
                  )}

                  <div className={localStorage.getItem("lang") == "ar" ? "termsData arabicTermData" : "termsData"}>
                    <ul
                      style={
                        localStorage.getItem("lang") == "ar"
                          ? { paddingLeft: "20px", paddingRight: "20px", textAlign: "right", direction: "rtl" }
                          : { paddingLeft: "20px", paddingRight: "20px", textAlign: "left" }
                      }>
                      {localStorage.getItem("plan") == "daily" || localStorage.getItem("plan") == "null" || localStorage.getItem("plan") == undefined
                        ? lan.terms === undefined
                          ? ""
                          : lan.terms.split("\n").map((str) => (
                              <>
                                <li>
                                  <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                                </li>
                              </>
                            ))
                        : lan.termsweekly === undefined
                        ? ""
                        : lan.termsweekly.split("\n").map((str) => (
                            <>
                              <li>
                                <p style={localStorage.getItem("lang") == "ar" ? { textAlign: "right" } : { textAlign: "left" }}>{str}</p>
                              </li>
                            </>
                          ))}{" "}
                    </ul>
                    <a href="/tnc">click here</a>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
